import { combineReducers } from 'redux';

import { Reducer } from '../../../../types';
import { StateAudioList, ScriptEditorAction } from '../../types';

import { stripItems } from '../../../../../utility/store';
import {
  getAudioListRequest,
  getAudioListSuccess,
  getAudioListFail,
  setOpenAudioInstructionModal,
} from '../../actions';

type ReducerOf<T extends keyof StateAudioList> = Reducer<StateAudioList, ScriptEditorAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getAudioListRequest.type:
      return state ? stripItems(state) : null;

    case setOpenAudioInstructionModal.type:
      return action.payload ? state : null;

    case getAudioListSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getAudioListRequest.type:
      return true;

    case getAudioListSuccess.type:
    case getAudioListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateAudioList>({
  data,
  loading,
});
